// extracted by mini-css-extract-plugin
module.exports = {"container":"ActionsInCenter_container__2IjUQ"};